window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.$ = window.jQuery = require('jquery');
    window.Popper = require('popper.js').default;

    require('bootstrap');
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import { createApp } from 'vue';
import { createI18n, useI18n } from 'vue-i18n';
import VueMoment3 from 'vue-moment-v3';
import CompetitionSelect from './frontend/components/competition-select.vue';
import Payment from './frontend/components/payment';
import PaymentSummary from './frontend/components/payment-summary';
import Participants from './frontend/components/participants';
import Competitions from './frontend/components/competitions/competitions';

import mitt from 'mitt';

const emitter = mitt();

function loadLocaleMessages() {
    const locales = require.context('./../../lang', false, /[A-Za-z0-9-_,\s]+\.json$/i);
    const messages = {};
    locales.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
            const locale = matched[1];
            messages[locale] = locales(key);
        }
    });
    return messages;
}

const i18n = createI18n(
    {
        legacy: false,
        globalInjection: true,
        locale: Mrt.config.lang,
        fallbackLocale: Mrt.config.langFallback,
        messages: loadLocaleMessages()
    }
);

let app = createApp(
    {
        components: {
            CompetitionSelect,
            Participants,
            Payment,
            PaymentSummary,
            Competitions,
        }
    })
    .use(i18n)
    .use(VueMoment3);
app.config.globalProperties.emitter = emitter;

// Load Vue only if container present
window.addEventListener('load', function () {
    if (!document.getElementById('main-wrapper-vue')) {
        return;
    }
    app.mount('#main-wrapper-vue');
});

import select2 from 'select2/dist/js/select2';
// import langet from 'select2/dist/js/i18n/et';
// require('moment');
require('nouislider');
import printJS from 'print-js';

import CoverPop from './frontend/CoverPop.js';
import StickySidebar from './jquery.sticky-sidebar.js';
